import AppTypeInput from './AppTypeInput'
import AppTypeNumber from './AppTypeNumber'
import AppTypeTextarea from './AppTypeTextarea'
import AppTypeSwitch from './AppTypeSwitch'
import AppTypeCheckbox from './AppTypeCheckbox'
import AppTypeImage from './AppTypeImage'
import AppTypeEditor from './AppTypeEditor'
import AppTypeMap from './AppTypeMap'

export default {
  AppTypeInput,
  AppTypeNumber,
  AppTypeTextarea,
  AppTypeSwitch,
  AppTypeCheckbox,
  AppTypeImage,
  AppTypeEditor,
  AppTypeMap
}
